import { FatInvestorsPageListInvestorsQuery } from '@/__generated__/graphql';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { useAuth } from '@/hooks/use-auth';
import { TenantType } from '@trace-8/trace8-schema';
import { investorColumns } from '../../constants';
import InvestorMobileSumFooter from './investorMobileSumFooter';

interface MobileTableInvestorProps {
  listInvestors: FatInvestorsPageListInvestorsQuery['listInvestors'];
  openInvestorDetailsPage: ({ investorId, entityId }: { investorId: string; entityId?: string }) => Promise<void>;
}

const MobileTableInvestor = ({ listInvestors, openInvestorDetailsPage }: MobileTableInvestorProps) => {
  const { user } = useAuth();

  const TableRow = ({ el }: { el: FatInvestorsPageListInvestorsQuery['listInvestors']['data'][number] }) => {
    return (
      <MobileTableRowWrap>
        <MobileRow>
          <MobileRowTitle>{investorColumns[0].title}</MobileRowTitle>
          <MobileRowValue isRedirect onClick={() => openInvestorDetailsPage({ investorId: el.id })}>
            {el.name}
          </MobileRowValue>
        </MobileRow>

        {user && user.tenant.type === TenantType.PLATFORM_MANAGER && (
          <MobileRow>
            <MobileRowTitle>{investorColumns[1].title}</MobileRowTitle>
            <MobileRowValue>{el.tenant.name}</MobileRowValue>
          </MobileRow>
        )}

        <MobileRow>
          <MobileRowTitle>{investorColumns[2].title}</MobileRowTitle>
          <MobileRowValue>{el.investmentCount}</MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{investorColumns[3].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip>{el.totalValue}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>

        <MobileRow>
          <MobileRowTitle>{investorColumns[4].title}</MobileRowTitle>
          <MobileRowValue>
            <FormattingTooltip>{el.totalCommitments}</FormattingTooltip>
          </MobileRowValue>
        </MobileRow>
      </MobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {listInvestors.data.length ? (
        <>
          {listInvestors.data.map((el) => (
            <TableRow el={el} key={el.id} />
          ))}
          <InvestorMobileSumFooter columns={investorColumns} totals={listInvestors.totals} />
        </>
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default MobileTableInvestor;
